import type { Color } from '@nxt-insurance/ui-kit/types'

export const getContrastColor = (color: Color): Color => {
  if (color === 'uiGreyLight') {
    return 'uiDark'
  }
  if (color === 'brandDark') {
    return 'uiLight'
  }
  if (color.includes('Dark')) {
    // @ts-expect-error TS cannot properly type the replace method
    return color.replace('Dark', 'Light')
  }
  if (color.includes('Light')) {
    // @ts-expect-error TS cannot properly type the replace method
    return color.replace('Light', 'Dark')
  }
  return 'uiLight'
}

export const itemsAlignmentTailwind = {
  top: 'items-start',
  center: 'items-center',
  bottom: 'items-end',
  left: 'items-start',
  right: 'items-end',
  stretch: 'items-stretch',
} as const

export const justifyAlignmentTailwind = {
  top: 'justify-start',
  center: 'justify-center',
  bottom: 'justify-end',
  left: 'justify-start',
  right: 'justify-end',
} as const
